<template>
  <div class="dr-btn-wrapper">
    <!-- button with custom url  -->
    <v-btn
      v-if="goToUrl"
      :class="typeBtn"
      :[link()]="goToUrl"
      :target="targetUrl"
      :disabled="btnEnabled"
      nuxt
      :data-cy="dataCy"
    >
      <slot />
    </v-btn>
    <!-- button with custom event  -->

    <v-btn
      v-else
      :class="typeBtn"
      :disabled="btnEnabled "
      :loading="loader"
      :color="colorBtn"
      @click="action"
      :data-cy="dataCy"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
/**
 * props:
 * typeBtn   - Class of button [orange_btn_large , white_btn_large, orange_btn_narrow , outline_small ]
 * action    -  Event name -  custom event handler for button
 * goToUrl   - The url link - use the button with href as link
 * targetUrl - use with goToUrl prop , define the target of the link _blank or _self
 */

export default {
  props: {
    loader: Boolean,
    typeBtn: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      required: false, // true??? not sure,
      default: () => {}
    },
    goToUrl: {
      type: String,
      required: false,
      default: ''
    },
    targetUrl: {
      type: String,
      required: false,
      default: '_self'
    },
    colorBtn: {
      type: String,
      required: false,
      default: ''
    },
    btnEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    link() {
      return this.goToUrl.startsWith('https://') ||
        this.goToUrl.startsWith('http://') ||
        this.goToUrl.startsWith('www.')
        ? 'href'
        : 'to'
    }
  }
}
</script>
